import * as React from 'react'
import { Appbar, Divider, Menu } from 'react-native-paper'
import { useLogoutMutation } from '../../../generated/graphql'
import { useContext } from 'react'
import { AuthContext } from '../../../contexts/auth-context'
import { usePushToken } from '../../../contexts/push-token.provider'
import { useTranslation } from 'react-i18next'
import * as Sentry from '@sentry/react-native'
import { NavigationBarMenuProps } from '../header.types'

export default function NavigationBarMenu(props: NavigationBarMenuProps) {
  const [visible, setVisible] = React.useState(false)
  const { navigation } = props
  const [LogoutUser, { client }] = useLogoutMutation()
  const authCtx = useContext(AuthContext)
  const pushToken = usePushToken()
  const { userId, isSuperAdmin } = useContext(AuthContext)
  const { t } = useTranslation('menuItems')

  const logout = async () => {
    authCtx.clearCurrentUser()
    try {
      await LogoutUser(
        pushToken ? { variables: { input: { token: pushToken } } } : undefined
      )
    } catch (error) {
      console.error('Failed to logout', error)
      Sentry.captureException(error)
    }
  }
  /**
   * NOTE! If you change state and then navigate, the state change fires on an unmounting component.
   * Thats why we have a timeout of 1 ms
   */
  return (
    <Menu
      visible={visible}
      onDismiss={() => setVisible(false)}
      anchorPosition={'bottom'}
      anchor={
        <Appbar.Action icon="dots-vertical" onPress={() => setVisible(true)} />
      }
    >
      <Menu.Item
        leadingIcon="information-outline"
        onPress={() => {
          setVisible(false)
          setTimeout(() => navigation.navigate('Intro'), 1)
        }}
        title={t('Intro') as string}
      />

      <Menu.Item
        leadingIcon="account-outline"
        onPress={() => {
          setVisible(false)
          setTimeout(() => navigation.navigate('Profile', { userId }), 1)
        }}
        title={t('Profile') as string}
      />

      <Menu.Item
        leadingIcon="cog-outline"
        onPress={() => {
          setVisible(false)
          setTimeout(() => navigation.navigate('Settings'), 1)
        }}
        title={t('Settings') as string}
      />

      <Menu.Item
        leadingIcon="network"
        onPress={() => {
          setVisible(false)
          setTimeout(() => navigation.navigate('MyNodes'), 1)
        }}
        title={t('My Nodes') as string}
      />

      <Menu.Item
        leadingIcon="credit-card"
        onPress={() => {
          setVisible(false)
          setTimeout(() => navigation.navigate('BillingList'), 1)
        }}
        title={t('Billing') as string}
      />

      <Menu.Item
        leadingIcon="account-group-outline"
        onPress={() => {
          setVisible(false)
          setTimeout(() => navigation.navigate('MyCollaborators', {}), 1)
        }}
        title={t('my-collaborators-page') as string}
      />

      <Menu.Item
        leadingIcon="clipboard-list-outline"
        onPress={() => {
          setVisible(false)
          setTimeout(
            () => navigation.navigate('MyTasks', { tab: 'pending' }),
            1
          )
        }}
        title={t('my-tasks') as string}
      />

      <Menu.Item
        leadingIcon="wallet"
        onPress={() => {
          setVisible(false)
          setTimeout(() => navigation.navigate('PaymentMethods'), 1)
        }}
        title={t('payment-methods') as string}
      />

      {isSuperAdmin ? (
        <Menu.Item
          leadingIcon="shield-account-outline"
          onPress={() => {
            setVisible(false)
            setTimeout(
              () => navigation.navigate('Admin', { screen: 'AdminHome' }),
              1
            )
          }}
          title={t('Admin') as string}
        />
      ) : null}

      <Divider />
      <Menu.Item
        leadingIcon="logout"
        onPress={() => {
          setVisible(false)
          logout().then()
        }}
        title={t('Log out') as string}
      />
    </Menu>
  )
}
